class ContentType {
  constructor(data) {
    this.pk = data.pk;
    this.name = data.name || '';
    this.app = data.app_label || '';
    this.name = data.entity_name || '';
    this.model = typeof data.model === 'string' ? data.model.charAt(0).toUpperCase() + data.model.slice(1) : '';
  }
}
export default ContentType;